<template>
  <div>
    <h1>Benutzer</h1>
    <h2 v-if="selectedItem && selectedItem.id > 0">Bearbeiten</h2>
    <h2 v-else-if="selectedItem && selectedItem.id == 0">Neu</h2>
    <button v-if="!selectedItem" @click="addItem">Neu</button>

    <LoadingSpinner v-if="isLoading"></LoadingSpinner>
    <template v-else>
      <template v-if="!selectedItem">
        <table v-if="items && items.length > 0" style="max-width: 100%;">
          <tr>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
          <tr v-for="item in items">
            <td>
              {{ item.username }}
            </td>
            <td>
              <button @click="deleteItem(item)">Löschen</button>
              <button @click="selectedItem = item">Bearbeiten</button>
            </td>
          </tr>
        </table>
        <template v-else>
          Keine Daten gefunden
        </template>
      </template>
      <template v-else>
        <div class="edit-form">
          <label>Name</label>
          <input type="text" v-model="selectedItem.username" maxlength="255" />
          <br />
          <label>Passwort</label>
          <input type="password" v-model="selectedItem.password" maxlength="255" />
        </div>

        <button @click="saveItem">Speichern</button>
        <button @click="selectedItem = null">Abbrechen</button>
      </template>
    </template>
  </div>
</template>

<script>
  import LoadingSpinner from '../../parts/LoadingSpinner'
  import rest from '../../../services/rest'
  import Vue from 'vue'

  export default {
    name: 'AdminUsers',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        isLoading: true,
        items: [],
        selectedItem: null
      }
    },
    methods: {
      loadItems () {
        this.isLoading = true
        rest.users.all((response, hasError) => {
          if (hasError) { return }
          this.items = response.body
          this.isLoading = false
        })
      },
      deleteItem (item) {
        if (!confirm('Wollen Sie das wirklich löschen?')) { return }
        this.isLoading = true
        rest.users.delete(item.id, (response, hasError) => {
          if (!hasError) {
            let index = this.items.indexOf(item)
            if (index > -1) {
              this.items.splice(index, 1)
            }
          }
          this.isLoading = false
        })
      },
      addItem () {
        let newItem = {
          id: 0,
          username: '',
          password: ''
        }
        this.selectedItem = newItem
      },
      saveItem () {
        this.isLoading = true
        if (this.selectedItem.id > 0) {
          // Update
          rest.users.update(this.selectedItem, (response, hasError) => {
            if (hasError) {
              this.isLoading = false
              return
            }
            let newItem = response.body
            let index = this.items.indexOf(this.selectedItem)
            Vue.set(this.items, index, newItem)
            this.selectedItem = null
            this.isLoading = false
          })
        } else {
          // Insert
          rest.users.add(this.selectedItem, (response, hasError) => {
            if (hasError) {
              this.isLoading = false
              return
            }
            let newItem = response.body
            this.items.push(newItem)
            this.selectedItem = null
            this.isLoading = false
          })
        }
      }
    },
    mounted () {
      this.loadItems()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-error {
    font-size: 18pt;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// AdminUsers.vue?77a53be0